// Which URLs render the medstudent clinic chart (MedStudentClinicPage).
//
// Four routes in App.js point at that one component: /clinic/:uuid,
// /visit/:uuid, /patient/:uuid and /patients/:uuid (the roster chart). Code
// that needs to know "am I on the clinic chart?" kept re-deriving that list and
// getting it wrong — the global BubbleContainer gate listed only two of the
// four, so /visit/:uuid and /patient/:uuid mounted a SECOND RecordingBubble on
// top of the chart's own. Both answered the broadcast `recordingBubbleOpen`,
// and the spare one — which has no patient, because App.js never sets
// `chatBubblePatientId` — toasted "No patient selected" over a recorder that
// had opened fine on the other instance.
//
// The `/edit-document` sub-routes (/patient/:uuid/edit-document,
// /visit/:uuid/edit-document/:documentId?) render EditableDocumentPage, a
// different page, so they are deliberately NOT matched.

/** Route prefixes whose `/:uuid` form renders the clinic chart. */
const CLINIC_CHART_SEGMENTS = ["clinic", "visit", "patient", "patients"];

const CLINIC_CHART_PATH = new RegExp(
  `^/(${CLINIC_CHART_SEGMENTS.join("|")})/[^/]+/?$`
);

/**
 * True when `pathname` renders MedStudentClinicPage.
 *
 * The clinic chart brings its own mic, AI panel and reports, so global
 * floating widgets hide here rather than stacking on top of it.
 */
export function isClinicChartPath(pathname) {
  return CLINIC_CHART_PATH.test(String(pathname || "").split("?")[0]);
}
